<template>
  <div class="lift-step-one">
    <v-layout
      wrap
      justify-space-between
    >
      <v-flex sm6>
        <v-switch
          v-model="form.idc_rectification"
          hide-details
          label="Rectification :"
          class="title mb-4 mt-0"
          @change="clearRectificationFields"
        />
        <v-radio-group
          v-model="form.rectification_type"
          hide-details
          row
          :disabled="!form.idc_rectification"
        >
          <v-radio
            label="Postérieur"
            value="POSTERIOR"
          />
          <v-radio
            label="Antérieur"
            value="ANTERIOR"
          />
        </v-radio-group>
        <v-checkbox
          v-model="form.idc_rectification_symmetrical"
          hide-details
          class="mt-4"
          label="Symétrique"
          :disabled="!form.idc_rectification"
        />

        <h4>Abduction en ° :</h4>
        <v-layout>
          <v-text-field
            v-model="form.rectification_abduction1"
            v-validate="'numeric|max:4'"
            data-vv-name="(Rectification) Abduction 1"
            :class="{ error: errors.has('(Rectification) Abduction 1') }"
            class="abduction"
            placeholder="ex: 120°"
            type="number"
            :disabled="!form.idc_rectification"
            outlined
            hide-details
          />
          <v-text-field
            v-model="form.rectification_abduction2"
            v-validate="'numeric|max:4'"
            data-vv-name="(Rectification) Abduction 2"
            :class="{ error: errors.has('(Rectification) Abduction 2') }"
            class="abduction"
            placeholder="ex: 120°"
            type="number"
            :disabled="!form.idc_rectification"
            outlined
            hide-details
          />
        </v-layout>
      </v-flex>

      <v-flex sm6>
        <h3 class="mt-2">
          Réglages :
        </h3>
        <v-layout
          justify-space-between
          wrap
        >
          <v-flex sm6>
            <v-checkbox
              v-model="form.idc_adjustable_adb"
              label="ABD Réglable"
              hide-details
            />
            <v-checkbox
              v-model="form.idc_growth_system"
              label="Système croissance"
              hide-details
            />
            <v-checkbox
              v-model="form.idc_catch_up_wedge"
              label="Cale de rattrapage"
              hide-details
            />
          </v-flex>

          <v-flex sm6>
            <v-select
              v-model="form.pedometer_module"
              :items="dropdowns.pedometer_module"
              item-text="label"
              item-value="value"
              label="Module pédieux"
              filled
              clearable
            />
          </v-flex>

          <v-flex
            xs12
            mt-6
          >
            <p>Schéma module pédieux :</p>
            <div class="content">
              <div class="img-container">
                <img src="@/assets/img/schema_verticalisateur_1a.svg">
                <v-text-field
                  v-model="form.pedometer_module_a"
                  v-validate="'numeric|max:4'"
                  data-vv-name="(Réglages) Schema A"
                  :class="{ error: errors.has('(Réglages) Schema A') }"
                  type="number"
                  style="top: 17.1%;left: 0.2%;"
                  height="100%"
                  outlined
                />
                <v-text-field
                  v-model="form.pedometer_module_b"
                  v-validate="'numeric|max:4'"
                  data-vv-name="(Réglages) Schema B"
                  :class="{ error: errors.has('(Réglages) Schema B') }"
                  type="number"
                  style="top: 66.8%;left: 38.4%;"
                  height="100%"
                  outlined
                />
                <v-text-field
                  v-model="form.pedometer_module_c"
                  v-validate="'numeric|max:4'"
                  data-vv-name="(Réglages) Schema C"
                  :class="{ error: errors.has('(Réglages) Schema C') }"
                  type="number"
                  style="top: 61.8%;left: 83.8%;"
                  height="100%"
                  outlined
                />
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex mt-12>

        <v-layout
          justify-space-between
          wrap
          class="mt-4"
        >
          <v-layout>
            <v-switch
              v-model="form.is_characteristics_enabled"
              hide-details
              class="mb-4 title"
              label="Caractéristique :"
              @change="clearCharacteristicsFields"
            />
          
          </v-layout>
        </v-layout>

        <v-layout
          class="specs"
          wrap
          justify-space-between
        >

          <v-checkbox
            v-model="form.idc_thick_foam"
            :disabled="!form.is_characteristics_enabled"
            hide-details
            label="Mousse épaisse sup à 30 mm"
          />


          <v-text-field
            v-model="form.rigid_foam"
            v-validate="'numeric|max:4'"
            data-vv-name="(Caractéristique) Mousse"
            :class="{ error: errors.has('(Caractéristique) Mousse') }"
            :disabled="!form.is_characteristics_enabled"
            label="Mousse mm rigide (mm)"
            placeholder="mm"
            type="number"
            outlined
            hide-details
          />
          <v-text-field
            v-model="form.plastazote"
            v-validate="'numeric|max:4'"
            data-vv-name="(Caractéristique) Plasta"
            :class="{ error: errors.has('(Caractéristique) Plasta') }"
            :disabled="!form.is_characteristics_enabled"
            label="Plasta"
            placeholder="mm"
            type="number"
            outlined
            hide-details
          />
          <v-text-field
            v-model="form.evazote"
            v-validate="'numeric|max:4'"
            data-vv-name="(Caractéristique) Evazote"
            :class="{ error: errors.has('(Caractéristique) Evazote') }"
            :disabled="!form.is_characteristics_enabled"
            label="Evazote"
            placeholder="mm"
            type="number"
            outlined
            hide-details
          />

          <v-layout class="color-select">
            <v-select
              v-model="form.transfer_id"
              :items="transferColors"
              item-text="label"
              item-value="id"
              :disabled="!form.is_characteristics_enabled"
              label="Transfert :"
              filled
              clearable
              @click:clear="$nextTick(() => (form.transfer_id = null))"
            />
            <template v-if="previewTransfer">
              <v-flex
                v-if="previewTransfer.texture == 'TEXTURE'"
                class="preview"
                style="width: 35px; height: 35px"
              >
                <img
                  :src="previewTransfer.image"
                  style="width: 100%; height:100%"
                  alt
                >
              </v-flex>
              <v-flex
                v-else-if="previewTransfer.texture == 'COLOR'"
                class="preview"
                :style="{ 'background-color': '#' + previewTransfer.rgb_code }"
              />
            </template>
          </v-layout>

        <v-layout class="color-select">
          <v-select
            v-model="form.thermozaic_color_id"
            :items="thermoColors"
            item-text="label"
            item-value="id"
            label="Finition"
            filled
            clearable
            :disabled="!form.is_characteristics_enabled"
            hide-details
            class="mb-4"
            @click:clear="$nextTick(() => (form.thermozaic_color_id = null))"
          />
          <v-flex
            v-if="previewThermoColor"
            class="preview"
            style="width: 35px; height: 35px"
          >
            <img
              v-if="previewThermoColor.texture == 'TEXTURE'"
              :src="previewThermoColor.image"
              style="width: 100%; height:100%"
              alt
            >
          </v-flex>
          <v-flex
            v-if="previewThermoColor == 'COLOR'"
            class="preview"
            :style="{ 'background-color': '#' + previewThermoColor.rgb_code }"
          />
        </v-layout>

        </v-layout>

        <v-textarea
          v-model="form.characteristics_comment"
          :disabled="!form.is_characteristics_enabled"
          label="Ajouter un commentaire..."
          filled
          rows="3"
          hide-details
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "LiftStepOne",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      transferColors: "colors/getTRANSFERType",
      thermoColors: "colors/getTHERMOType",

      dropdowns: "dropdowns/getLiftOptions"
    }),

    // Returns transfer textures
    previewTransfer() {
      return this.transferColors.find(item => item.id == this.form.transfer_id);
    }
  },
  created() {
    this.$validator = this.parentValidator;
  },
  methods: {
    // Clear rectification fields
    clearRectificationFields() {
      this.form.rectification_type = null;
      this.form.idc_rectification_symmetrical = false;
      this.form.rectification_abduction1 = null;
      this.form.rectification_abduction2 = null;
    },
    
    // Clear characteristics fields when section is disabled
    clearCharacteristicsFields() {
      if (!this.form.is_characteristics_enabled) {
        this.form.idc_thick_foam = false;
        this.form.rigid_foam = null;
        this.form.plastazote = null;
        this.form.evazote = null;
        this.form.transfer_id = null;
        this.form.characteristics_finishing = null;
        this.form.characteristics_comment = null;
      }
    }
  }
};
</script>

<style lang="scss">
.lift-step-one {
  .img-container {
    position: relative;
    display: inline-block;
    margin: auto;
    width: 100%;
    img {
      height: 100%;
      width: 100%;
      @media (max-width: 800px) {
        min-width: auto;
      }
    }
    .v-input {
      position: absolute;
      width: 15.5%;
      height: 27.1%;
      @media (max-width: 800px) {
        height: 27.1%;
      }
      .v-input__control {
        height: 100%;
        .v-input__slot {
          min-height: auto;
        }
      }
    }
  }
  .sm6 {
    flex-basis: calc(100% / 2 - 7px);
  }
  .abduction {
    margin-top: 5px;
    flex-basis: 73px;
    flex-grow: 0;
    margin-right: 15px;
  }
  .v-input--selection-controls {
    &.v-input {
      margin: 0;
      padding: 0;
    }
  }
  .content {
    border: 1px solid #707070;
    padding: 15px;
  }
  .specs {
    > * {
      &:not(:last-child) {
        width: calc(100% / 2 - 7px) !important;
        flex-grow: 0;
        margin-bottom: 15px;
      }
    }
  }
  h3 {
    margin-bottom: 15px;
  }
}
</style>
